<template>
  <div class="wrapper wrapper-content p-0 animated fadeInUp">
    <div class="ibox-body">
      <!-- Header with add icon -->
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ $t("navigations.cohort list") }}</h5>
        <div class="position-relative align-self-center">
        <img src="@/assets/img/create.png" width="17"  height="17" alt="Add Cohort" style="cursor: pointer;" @click="addNewRow" />
          <div class="tool-tip mt-2">Add Cohort</div>
      </div>
      </div>
      <div class="ibox-content">
      
        <div >
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                   <th>Cohort ID <sup><i class="fa fa-asterisk required"></i></sup>
                    <!-- <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span> -->
                  </th>
                  <th>Cohort Code <sup><i class="fa fa-asterisk required"></i></sup>
                    <!-- <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span> -->
                  </th>
                  <th>Cohort Name <sup><i class="fa fa-asterisk required"></i></sup>
                    <!-- <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span> -->
                  </th>
                  <th>Cohort Number <sup><i class="fa fa-asterisk required"></i></sup>
                    <!-- <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span> -->
                  </th>
                  <th>Description</th>
                  <th>Dose Amount</th>
                  <th>Dose Unit</th>
                  <th>Dose Route</th>
                  <th>Dose Frequency</th>
                  <th>Dose Formulation</th>
                  <th>SoA ID</th>
                  <th class="text-center sticky-column">Edit</th>
                  <th class="text-center">Delete</th>
                </tr>
              </thead>
              <tbody>
                <!-- New Row for creation -->
                <tr v-if="isAddingNew">
                  <td>
                    <input v-model="newRow.cohortId" class="form-control" type="text"
                      @input="clearNewFieldError('cohortId')" />
                    <div v-if="newRowErrors.cohortId" class="text-danger">{{ newRowErrors.cohortId }}</div>
                  </td>
                  <td>
                    <input v-model="newRow.cohortCode" class="form-control" type="text"
                      @input="clearNewFieldError('cohortCode')" />
                    <div v-if="newRowErrors.cohortCode" class="text-danger">{{ newRowErrors.cohortCode }}</div>
                  </td>
                  <td>
                    <input v-model="newRow.cohortName" class="form-control" type="text"
                      @input="clearNewFieldError('cohortName')" />
                    <div v-if="newRowErrors.cohortName" class="text-danger">{{ newRowErrors.cohortName }}</div>
                  </td>
                  <td>
                    <input v-model="newRow.cohortNumber" class="form-control" type="number" />
                  </td>
                  <td>
                    <textarea v-model="newRow.description" class="form-control" rows="3"></textarea>
                  </td>
                  <td>
                    <input v-model="newRow.doseAmount" class="form-control" type="number" />
                  </td>
                  <td>
                    <input v-model="newRow.doseUnit" class="form-control" type="text" />
                  </td>
                  <td>
                    <input v-model="newRow.doseRoute" class="form-control" type="text" />
                  </td>
                  <td>
                    <input v-model="newRow.doseFrequency" class="form-control" type="text" />
                  </td>
                  <td>
                    <input v-model="newRow.doseFormulation" class="form-control" type="text" />
                  </td>
                  <td>
                    <input v-model="newRow.soaId" class="form-control" type="text" />
                  </td>
                  <td class="text-center sticky-column">
                    <i class="fa fa-check action-icon text-success" @click="saveNewRow" title="Save"></i>
                    <i class="fa fa-times action-icon text-danger" @click="cancelNewRow" title="Cancel"></i>
                  </td>
                  <td></td>
                </tr>
                    <!-- No data row -->
              <tr v-if="!isAddingNew && cohorts.length === 0">
                <td colspan="11" class="text-center">No data available.</td>
              </tr>
                <tr v-for="(cohort, index) in cohorts" :key="cohort.id">
                  <!-- Cohort ID -->
                  <td v-if="editIndex !== index">{{ cohort.cohortId }}</td>
                  <!-- Cohort Code -->
                  <td v-if="editIndex !== index">{{ cohort.cohortCode }}</td>
                  <td v-else>
                    <input v-model="editableRow.cohortCode" class="form-control" type="text"
                      @input="clearFieldError('cohortCode')" />
                    <div v-if="validationErrors.cohortCode" class="text-danger">{{ validationErrors.cohortCode }}</div>
                  </td>

                  <!-- Cohort Name -->
                  <td v-if="editIndex !== index">{{ cohort.cohortName }}</td>
                  <td v-else>
                    <input v-model="editableRow.cohortName" class="form-control" type="text"
                      @input="clearFieldError('cohortName')" />
                    <div v-if="validationErrors.cohortName" class="text-danger">{{ validationErrors.cohortName }}</div>
                  </td>

                  <!-- Cohort Number -->
                  <td v-if="editIndex !== index">{{ cohort.cohortNumber }}</td>
                  <td v-else>
                    <input v-model="editableRow.cohortNumber" class="form-control" type="number"
                      @input="clearFieldError('cohortNumber')" />

                  </td>

                  <!-- Description -->
                  <td v-if="editIndex !== index">
                    <div class="wrap-text">{{ cohort.description }}</div>
                  </td>
                  <td v-else>
                    <textarea v-model="editableRow.description" class="form-control" rows="3"></textarea>
                  </td>

                  <!-- Dose Amount — read: cohort.dose.amount | edit: editableRow.doseAmount -->
                  <td v-if="editIndex !== index">{{ cohort.dose?.amount }}</td>
                  <td v-else>
                    <input v-model="editableRow.doseAmount" class="form-control" type="number" />
                  </td>

                  <!-- Dose Unit -->
                  <td v-if="editIndex !== index">{{ cohort.dose?.unit }}</td>
                  <td v-else>
                    <input v-model="editableRow.doseUnit" class="form-control" type="text" />
                  </td>

                  <!-- Dose Route -->
                  <td v-if="editIndex !== index">{{ cohort.dose?.route }}</td>
                  <td v-else>
                    <input v-model="editableRow.doseRoute" class="form-control" type="text" />
                  </td>

                  <!-- Dose Frequency -->
                  <td v-if="editIndex !== index">{{ cohort.dose?.frequency }}</td>
                  <td v-else>
                    <input v-model="editableRow.doseFrequency" class="form-control" type="text" />
                  </td>

                  <!-- Dose Formulation -->
                  <td v-if="editIndex !== index">{{ cohort.dose?.formulation }}</td>
                  <td v-else>
                    <input v-model="editableRow.doseFormulation" class="form-control" type="text" />
                  </td>
                  <!-- SoA ID -->
                  <td v-if="editIndex !== index">{{ cohort.soaId }}</td>
                  <td v-else>
                    <input v-model="editableRow.soaId" class="form-control" type="text" />
                  </td>

                  <!-- Edit Actions -->
                  <td class="text-center sticky-column">
                    <template v-if="editIndex !== index">
                      <i class="fa fa-edit edit-delete" v-if="protocol.status !== 'Generated'"
                        @click.prevent="editRow(index, cohort)"></i>
                    </template>
                    <template v-else>
                      <i class="fa fa-check action-icon text-success" @click="updateRow(cohort.id)" title="Update"></i>
                      <i class="fa fa-times action-icon text-danger" @click="cancelEdit" title="Cancel"></i>
                    </template>
                  </td>

                  <!-- Delete -->
                  <td class="text-center">
                    <i class="fa fa-trash edit-delete" v-if="protocol.status !== 'Generated'" style="color: #a13b7c"
                      @click="deleteRow(cohort.id)"></i>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="row mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination v-model="currentPage" :pages="totalPages" :range-size="0" active-color="#618bd7"
                    @update:modelValue="loadPage" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.action-icon {
  cursor: pointer;
  font-size: 18px;
  margin: 0 5px;
}

.action-icon:hover {
  opacity: 0.8;
}

.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}

.wrap-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 200px;
  overflow: hidden;
}

textarea.form-control {
  resize: vertical;
  max-height: 150px;
}

.sticky-column {
  position: sticky;
  right: 0;
  background-color: #fff;
  z-index: 10;
  border-left: 1px solid #dee2e6;
}
.position-relative .tool-tip {  
  right: 20px;
  top: 0px;
}
</style>

<script src="./CohortManagement.js"></script>